import { parseNumberInput } from './layerDraft'

export const typeDeColonne = (schema, cle) => {
  const jtype = schema?.[cle]
  if (jtype === 'boolean') return 'boolean'
  if (jtype === 'number') return 'number'
  return 'text'
}

export const deduireType = valeurs => {
  if (valeurs.some(v => typeof v === 'boolean')) return 'boolean'
  if (valeurs.some(v => typeof v === 'number')) return 'number'
  return 'text'
}

// Le schema serveur est un echantillon ou un seul null masque le type : les valeurs tranchent alors.
export const typeDeValeur = (schema, cle, valeurs) =>
  schema &&
  Object.prototype.hasOwnProperty.call(schema, cle) &&
  schema[cle] !== 'null'
    ? typeDeColonne(schema, cle)
    : deduireType(valeurs)

export const valeurAEnregistrer = (type, saisie) => {
  if (type === 'boolean') return { valeur: saisie === true }
  if (type === 'number') {
    const { value, error } = parseNumberInput(saisie)
    return error ? { erreur: error } : { valeur: value }
  }
  return { valeur: String(saisie ?? '') }
}

// Une saisie identique a l'origine ne part jamais : une case absente reste absente.
export const proprietesModifiees = (initiales, saisies, typeDe) => {
  const proprietes = {}
  const erreurs = {}
  Object.entries(saisies).forEach(([cle, saisie]) => {
    if (Object.is(saisie, initiales[cle])) return
    const { valeur, erreur } = valeurAEnregistrer(typeDe(cle), saisie)
    if (erreur) erreurs[cle] = erreur
    else if (!Object.is(valeur, initiales[cle])) proprietes[cle] = valeur
  })
  return { proprietes, erreurs }
}

const OUI_NON = ['true', 'false']

// Une colonne neuve ne contient que false : sans ce complement, le style n'offrirait pas « Oui ».
export const completerClassesOuiNon = uniques => {
  const ouiNon =
    uniques.length > 0 && uniques.every(u => OUI_NON.includes(String(u.value)))
  if (!ouiNon) return uniques
  return OUI_NON.map(value => ({
    value,
    count: uniques.find(u => String(u.value) === value)?.count ?? 0,
  }))
}

export const classeCategorielle = valeur => {
  if (valeur === true || valeur === 'true')
    return { value: 'true', label: 'Oui' }
  if (valeur === false || valeur === 'false')
    return { value: 'false', label: 'Non' }
  return { value: valeur, label: String(valeur) }
}
